export default __webpack_public_path__ + "static/media/specialization_reinforcemnetlearning.a263cb33.png";